import {
  TOGGLE_EDITOR,
  CLOSE_EDITOR,
  ACTIVATE_A_EDITOR,
  SET_EDITOR_TYPE,
  UPDATE_OVERVIEW_EDITS,
} from './types';
import api from '../../lib/api';
import endpoints from '../../lib/endpoints';

// import { storeSelectedTrek } from "./selectedTrekActions";
export const toggleEditorModal = () => ({ type: TOGGLE_EDITOR });
export const closeEditor = () => ({ type: CLOSE_EDITOR });
export const activateEditor = editor => ({
  type: ACTIVATE_A_EDITOR,
  payload: editor,
});
export const renderEditorsAsModal = val => ({
  type: SET_EDITOR_TYPE,
  payload: val,
});

export const patchOverviewEdits = (trekId, data) => async () => {
  const response = await api.patch(endpoints.treks.editTrekData(trekId), data);

  return response.status === 200 ? response.data : response;
};

export const handleFreeze = (trekId, isFrozen) => async () => {
  if (isFrozen) {
    await api.delete(endpoints.treks.freeze(trekId));
  } else {
    await api.put(endpoints.treks.freeze(trekId));
  }
};

export const updateOverviewEdits = patchObj => ({
  type: UPDATE_OVERVIEW_EDITS,
  payload: patchObj,
});



// WEBPACK FOOTER //
// ./src/redux/actions/overviewEditorActions.js